import React, { Component } from "react";
import { Card as RBCard, Col, Row, Container } from "react-bootstrap";
import ReportFiltersContainer from "../../Filter/ReportFiltersContainer";
import { withTranslation } from "react-i18next";
import ReportToolbar from "../../Report/ReportToolbar";
import { getReportHelpLink } from "../../../lib/common";

class Card extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showFiltersSection: true
        };
    }

    handleShow = (e) => {
        e.preventDefault();
        this.setState((prevState) => ({
            showFiltersSection: !prevState.showFiltersSection
        }));
    };

    render() {
        const titleColumn = {
            xs: 12,
            sm: this.props.reportToolbar ? 12 : 12,
            lg: this.props.reportToolbar ? 6 : 12
        };

        const cardId = this.props.id ?? `${Date.now()}-${Math.random()}`;
        const customClasses = [
            this.props.hidden && "card-hidden",
            this.props.calendar && "card-calendar",
            this.props.plain && "card-plain",
            this.props.wizard && "card-wizard",
            this.props.custom,
        ]
            .filter(Boolean)
            .join(" ");

        const contentClasses = [
            this.props.ctAllIcons && "all-icons",
            this.props.ctFullWidth && "content-full-width",
            this.props.ctTextCenter && "text-center",
            this.props.tableFullWidth && "table-full-width",
            this.props.wizard && "wizard-content",
            this.props.contentClass,
        ]
            .filter(Boolean)
            .join(" ");

        return (
            <RBCard className={customClasses} id={cardId} style={this.props.style}>
                {(this.props.title || this.props.category || (this.props.reportToolbar?.filter?.enabled)) && (
                    <RBCard.Header className={this.props.textCenter ? "text-center" : ""}>
                        <Container fluid>
                            <Row>
                                <Col xs={titleColumn.xs} sm={titleColumn.sm} lg={titleColumn.lg}>
                                    <RBCard.Title
                                        as="h4"
                                        id={this.props.titleID ?? ""}
                                        className="card-title card-title-captialize"
                                    >
                                        {this.props.title}
                                    </RBCard.Title>
                                    <span id={this.props.categoryID ?? ""} className="category">
                                        {this.props.category}
                                    </span>
                                    {this.props.helpLinkReport && !this.props.helpLinkReport.endsWith("Workflow") && (
                                        <a
                                            aria-current="page"
                                            className="report-help-link"
                                            href={getReportHelpLink(this.props.helpLinkReport)}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            &nbsp;<span className="link-text">{this.props.helpLinkText}</span>
                                        </a>
                                    )}
                                </Col>
                                {this.props.reportToolbar && (
                                    <Col xs={12} sm={12} lg={6} className="colNoPadding d-flex justify-content-end align-items-center flex-wrap">
                                        <ReportToolbar
                                            isInstanceReport={this.props.reportToolbar.isInstanceReport}
                                            currentWorkbook={this.props.reportToolbar.currentWorkbook}
                                            timeframe={this.props.reportToolbar.timeframe}
                                            filter={this.props.reportToolbar.filter}
                                            showFiltersSection={this.state.showFiltersSection}
                                            handleShow={this.handleShow}
                                            drill={this.props.reportToolbar.drill}
                                            more={this.props.reportToolbar.more}
                                        />
                                    </Col>
                                )}
                            </Row>
                        </Container>
                    </RBCard.Header>
                )}

                {this.props.filterPanel?.enabled && (
                    <div hidden={this.state.showFiltersSection}>
                        <ReportFiltersContainer
                            {...this.props.filterPanel}
                            filterType={this.props.filterPanel.currentReportFilters.reportType==='current' ? "Current" : "Historical"}
                            isInstanceReport={this.props.reportToolbar.isInstanceReport}
                            workbookName={this.props.reportToolbar?.currentWorkbook?.workbookName}
                        />
                    </div>
                )}

                <RBCard.Body className={contentClasses}>
                    {this.props.content}
                </RBCard.Body>

                {(this.props.stats || this.props.legend) && (
                    <RBCard.Footer className={this.props.ftTextCenter ? "text-center" : ""}>
                        {this.props.legend && <div className="legend">{this.props.legend}</div>}
                        {this.props.stats && (
                            <>
                                <hr />
                                <div className="stats">{this.props.stats}</div>
                            </>
                        )}
                    </RBCard.Footer>
                )}
            </RBCard>
        );
    }
}

export default withTranslation()(Card);